import { IIntegrationRetryResult, IntegrationRetryOutcome } from '../../../queries/Admin/IntegrationsHealth';

export interface IRetryReport {
	severity: 'success' | 'info' | 'warning' | 'error';
	text: string;
}

/** Refusals that describe a deliberate state rather than something to go and fix. */
const STATE_REFUSALS: Partial<Record<IntegrationRetryOutcome, string>> = {
	SkippedAlreadyRunning: 'already syncing - refresh in a moment',
	SkippedDisabled: 'disabled',
};

export function buildRetryReport(results: IIntegrationRetryResult[]): IRetryReport {
	const retried = results.filter(r => r.outcome === 'Retried').length;
	const refusals = results.filter(r => r.outcome !== 'Retried');

	if (!refusals.length) {
		return {
			severity: 'success',
			text: `Retried ${retried} ${retried === 1 ? 'integration' : 'integrations'}.`,
		};
	}

	const sharedOutcome = refusals.every(r => r.outcome === refusals[0].outcome) ? refusals[0].outcome : null;
	const stateReason = sharedOutcome ? STATE_REFUSALS[sharedOutcome] : undefined;
	const detail = stateReason
		? ` ${refusals.length === 1 ? 'It is' : 'They are'} ${stateReason}.`
		: ` ${refusals[0].message}`.trimEnd();

	if (retried > 0) {
		return {
			severity: 'warning',
			text: `Retried ${retried} of ${results.length}. ${refusals.length} could not be started.${detail}`,
		};
	}

	const summary = refusals.length === 1 ? 'that integration' : `any of those ${refusals.length} integrations`;
	return stateReason
		? { severity: 'info', text: `Didn't start ${summary}.${detail}` }
		: { severity: 'error', text: `Couldn't start ${summary}.${detail}` };
}
